import * as mutationTypes from './types/mutation_types';

import initialState from './initialState';

export default {
  [mutationTypes.INGREDIENTS_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },
  [mutationTypes.INGREDIENTS_SUCCESS](state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },
  [mutationTypes.INGREDIENTS_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true,
    });
  },
  [mutationTypes.INGREDIENTS_RESET](state) {
    Object.assign(state, ...initialState);
  },
  [mutationTypes.INGREDIENTS_SELECT](state, payload) {
    Object.assign(state, { selected: payload });
  },
  [mutationTypes.INGREDIENTS_SELECT_RESET](state) {
    Object.assign(state, { selected: { title: '' } });
  },
  [mutationTypes.INGREDIENTS_CATEGORY](state, payload) {
    Object.assign(state, { category: payload });
  },
};
